import React, { FunctionComponent } from 'react'
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
// @ts-ignore
import { CSVLink } from 'react-csv'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { ChartIcon } from 'Stories/Icon/Icon.stories'

import { PlaylistChartAdminProps } from './PlaylistChartAdminProps'
import {
  ChartWrapper,
  ChartHeader,
  ChartTitle,
  ChartDays,
  StyledButton,
  StyledArea,
} from './styles'

const PlaylistChartAdmin: FunctionComponent<PlaylistChartAdminProps> = ({
  followersData,
}) => {
  const { t } = useTranslation()

  const dataFormatted =
    followersData &&
    followersData.map(item => ({
      followers: item.followers,
      updated: moment(item.updated).format('DDMMM'),
    }))
  return (
    <ChartWrapper>
      <ChartHeader>
        <div>
          <ChartTitle>
            {t('adminPage.followersChart')}&nbsp;
            <ChartDays>{t('adminPage.last30Days')}</ChartDays>
          </ChartTitle>
        </div>
        <div>
          {followersData && (
            <CSVLink data={followersData} filename="followers.csv">
              <StyledButton type="button">
                <ChartIcon />
              </StyledButton>
            </CSVLink>
          )}
        </div>
      </ChartHeader>

      <StyledArea>
        <ResponsiveContainer width="100%" height={234}>
          <AreaChart data={dataFormatted}>
            <CartesianGrid strokeDasharray="2 6" />
            <XAxis dataKey="updated" />
            <YAxis
              tickCount={4}
              type="number"
              dataKey="followers"
              domain={['dataMin', 'dataMax']}
            />
            <Tooltip />
            <Area dataKey="followers" stroke="#1CB954" fill="#1CB954" />
          </AreaChart>
        </ResponsiveContainer>
      </StyledArea>
    </ChartWrapper>
  )
}

export default PlaylistChartAdmin
